
import { defineComponent, ref, onBeforeMount } from 'vue';
import { invokeGetUserRole } from '@/utils/admin/master_service';
import { getApi, postApi } from '@/utils/ApiCalls';
import moment from 'moment';
// eslint-disable-next-line
import router from '@/router';
import { AxiosError } from 'axios';

export default defineComponent({
  name: 'EmailTemplateManagement',
  components: {},
  setup() {
    const loggedInUser = ref();
    const userRole = ref();
    const emailTemplates = ref([]);
    const renderReady = ref(true);
    const editTemplateBtn = ref(false);
    const editTemplateID = ref('');
    const templateCheck = ref([]);
    const learnerOhrs = ref('');
    const toOhrPatternMatch = ref(true);
    const showSendEmailBtn = ref(false);
    const selectedOption = ref('');
    const dropdownOpen = ref(false);

    const checkOne = () => {
      templateCheck.value = [];
    };

    const getAllEmailTemplates = async () => {
      renderReady.value = false;
      try {
        const response = await getApi(`/email/templates?name=managers`);
        emailTemplates.value = response.data.body.Items;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        emailTemplates.value.map((template: any) => {
          // eslint-disable-next-line no-param-reassign
          template.created_date = moment(template.created_date).format('DD-MM-YYYY hh:mm:ss');
          // eslint-disable-next-line no-param-reassign
          template.modified_date = moment(template.modified_date).format('DD-MM-YYYY hh:mm:ss');
          return template;
        });
        renderReady.value = true;
      } catch (error) {
        const err = error as AxiosError;
        console.log(err.response);
      }
    };

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const showTemplateEditBtn = async (event: any, templateID: any) => {
      if (event.target.checked === true) {
        editTemplateBtn.value = true;
        editTemplateID.value = templateID;
      } else {
        editTemplateBtn.value = false;
        editTemplateID.value = '';
      }
    };

    const editTemplate = async () => {
      console.log('template editing', editTemplateID.value);
      const result = {
        template: editTemplateID.value,
        is_new: 'false',
      };
      router.push({ name: 'SolidifyAdministrationEmailTemplateDetails', query: result });
    };

    const sendEmail = async () => {
      try {
        renderReady.value = false;
        console.log('Renderready value', renderReady.value);
        const data = { ohrs: learnerOhrs.value, cc: learnerOhrs.value, templateDetails: emailTemplates.value };
        console.log('Data ->', data);
        const response = await postApi(`/comms/send/individual/email?multiple_emails=true`, data);
        renderReady.value = true;
        console.log('Renderready value', renderReady.value);
        learnerOhrs.value = '';
        showSendEmailBtn.value = false;
      } catch (error) {
        renderReady.value = true;
        console.log('Error while sending emails', error);
      }
    };

    const matchOHRRegex = (ohr: any) => {
      toOhrPatternMatch.value = ohr.match(/^(\d{9},)*\d{9}$/) !== null;
      if (toOhrPatternMatch.value) showSendEmailBtn.value = true;
      else showSendEmailBtn.value = false;
      console.log('toOhrPatternMatch ->', toOhrPatternMatch.value);
    };

    const toggleDropdown = async () => {
      dropdownOpen.value = !dropdownOpen.value;
    };

    onBeforeMount(async () => {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        renderReady.value = false;
        const role: any = await invokeGetUserRole('/getUserRole');
        loggedInUser.value = role.user_key;
        userRole.value = role.user_roles;
        if (userRole.value.length > 0) {
          if (userRole.value.includes('System Admin')) {
            await getAllEmailTemplates();
            renderReady.value = true;
          } else {
            renderReady.value = false;
          }
        }
      } catch (error) {
        console.log('Error in onBeforeMount', error);
        renderReady.value = false;
      }
    });
    return {
      loggedInUser,
      userRole,
      emailTemplates,
      renderReady,
      showTemplateEditBtn,
      editTemplateBtn,
      editTemplate,
      templateCheck,
      checkOne,
      sendEmail,
      learnerOhrs,
      matchOHRRegex,
      toOhrPatternMatch,
      showSendEmailBtn,
      selectedOption,
      dropdownOpen,
      toggleDropdown,
    };
  },
});
